<top-navig [display]="true" [displayLogo]="false" title="Mentions légales"></top-navig>
<div class="mlegal" [class.p-95]="ourApp">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <!-- <h1 class="text-center">Mentions légales</h1> -->
                <p class="m-40">
                    Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la
                    Confiance dans l'économie numérique, nous informons les utilisateurs et visiteurs du site Internet
                    {{website}}
                </p>
                <h4 class="heading">Editeur du site :</h4>
                <hr class="half_space">
                <p>
                    {{restaurant}} <br>
                    Pays : France<br>
                    {{address}}<br>
                    Téléphone : {{phone}}<br>
                    {{email}}

                </p>
                <h4 class="heading">Hébergeur :</h4>
                <hr class="half_space">
                <p>
                    <a href="https://www.helpyfood.com" target="_blank"
                        rel="noopener noreferrer">www.helpyfood.com</a><br>
                    contact@helpyfood.com
                </p>
                <h4 class="heading">Responsable éditorial :
                </h4>
                <hr class="half_space">
                <p>
                    {{restaurant}}<br>
                    {{address}}<br>
                    {{phone}}<br>
                    {{email}}
                </p>
                <h4 class="heading">WEBMASTER :</h4>
                <hr class="half_space">
                <p>
                    <a href="https://www.helpyfood.com" target="_blank"
                        rel="noopener noreferrer">www.helpyfood.com</a><br>
                    contact@helpyfood.com</p>
            </div>
        </div>
    </div>
</div>